import { render, staticRenderFns } from "./NewsCenterDetail.vue?vue&type=template&id=68be10c0&scoped=true&"
import script from "./NewsCenterDetail.vue?vue&type=script&lang=js&"
export * from "./NewsCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewsCenterDetail.vue?vue&type=style&index=0&id=68be10c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68be10c0",
  null
  
)

export default component.exports